import { useCallback, useEffect, useState } from 'react'
import { api, type Nachfrage as NachfrageDaten } from '../api'

/**
 * Die Frage der App an den Nutzer (Konto → Nachfragen): oben im Tagebuch, bis er antwortet oder sie weglegt.
 * Die Antwort ist eine ganz normale Notiz (gesprochen oder getippt), die mit der Frage verknüpft ist.
 */
export function Nachfrage({
  version,
  antwortAuf,
  onSprechen,
  onTippen,
  onAbbrechen,
}: {
  /** Ändert sich, wenn neu geladen werden soll (z. B. nach einer Antwort) */
  version: number
  /** Id der Frage, auf die gerade geantwortet wird (Sprache bereit oder Texteingabe offen) */
  antwortAuf: number | null
  onSprechen: (frage: NachfrageDaten) => void
  onTippen: (frage: NachfrageDaten) => void
  onAbbrechen: () => void
}) {
  const [frage, setFrage] = useState<NachfrageDaten | null>(null)
  const [fehler, setFehler] = useState<string | null>(null)
  const [aufgeloest, setAufgeloest] = useState(false)

  const laden = useCallback(() => {
    api.nachfrageAktuell().then((f) => {
      setFrage(f)
      setAufgeloest(false)
    }).catch(() => {})
  }, [])
  useEffect(laden, [laden, version])

  if (!frage) return null
  const weglegen = async (aktion: () => Promise<void>) => {
    try {
      await aktion()
      onAbbrechen()
      setFrage(null)
    } catch (e) {
      setFehler((e as Error).message)
    }
  }
  const antwortet = antwortAuf === frage.id

  return (
    <section className="karte nachfrage">
      <p className="klein leise">{frage.art === 'VERKNUEPFEN' ? '🔗 Passt das zusammen?' : '💭 Weißt du noch?'}</p>
      <p>
        <strong>{frage.frage}</strong>
      </p>
      {frage.aufloesung && (
        <p className="leise">
          {aufgeloest ? (
            <>Das steht in deinen Notizen: {frage.aufloesung}</>
          ) : (
            <button className="link" onClick={() => setAufgeloest(true)}>
              Auflösung zeigen
            </button>
          )}
        </p>
      )}
      {antwortet ? (
        <p className="leise">Tippe auf den roten Knopf und sprich deine Antwort, oder schreib sie auf.</p>
      ) : null}
      {fehler && <p className="fehler">{fehler}</p>}
      <div className="knoepfe links">
        <button onClick={() => onSprechen(frage)} disabled={antwortet}>
          Per Sprache antworten
        </button>
        <button className="zweitrangig" onClick={() => onTippen(frage)}>
          Tippen
        </button>
        {antwortet && (
          <button className="zweitrangig" onClick={onAbbrechen}>
            Abbrechen
          </button>
        )}
      </div>
      <div className="knoepfe links">
        <button className="link" onClick={() => weglegen(() => api.nachfrageUebersprungen(frage.id))}>
          Überspringen
        </button>
        <button className="link gefahr" onClick={() => weglegen(() => api.nachfrageNie(frage.id))}>
          Dazu nicht mehr fragen
        </button>
      </div>
    </section>
  )
}
